import { css } from 'linaria';

/**
 * @prop --lct-color: text color
 */
export namespace Styles {
  export const text = css`
    color: var(--lct-color);
  `;
}
